/* NOA Matcha - product page buy box.
   Variant selection, gallery, price line, people picker, venue card and the
   add-to-cart / straight-to-checkout flow. Everything added for the CR brief
   (Z-261003-01) is driven by values the section writes into its JSON block;
   with the section settings at their defaults the behaviour is the same as
   before. The price format comes from the shop's money_format setting; the
   digit grouping follows the page locale. */
(function () {
  "use strict";

  function boot(root) {
    if (!root || root.dataset.alphaReady === "1") return;
    root.dataset.alphaReady = "1";

    var dataEl = root.querySelector("[data-alpha-variants]");
    if (!dataEl) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = cfg.variants || [];
    var fmt = cfg.moneyFormat || "{{amount}}";
    var idInput = root.querySelector("[data-alpha-id]");
    var qtyInput = root.querySelector("[data-alpha-qty]");
    var elNow = root.querySelector("[data-alpha-price]");
    var elWas = root.querySelector("[data-alpha-compare]");
    var elSave = root.querySelector("[data-alpha-save]");
    var elPer = root.querySelector("[data-alpha-per]");
    var elTotal = root.querySelector("[data-alpha-total]");
    var elSum = root.querySelector("[data-alpha-sum]");
    var elBtn = root.querySelector("[data-alpha-submit]");
    var elExpress = root.querySelector("[data-alpha-express]");
    var elStepper = root.querySelector("[data-alpha-stepper]");
    var segWrap = root.querySelector("[data-alpha-segs]");
    var segInputs = segWrap ? Array.prototype.slice.call(segWrap.querySelectorAll("input[type=radio]")) : [];
    var venueWrap = root.querySelector("[data-alpha-venues]");
    var venueCards = venueWrap ? Array.prototype.slice.call(venueWrap.querySelectorAll("[data-venue-match]")) : [];
    var venueProp = root.querySelector("[data-alpha-venue-prop]");
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var segMode = !!(cfg.segments && segWrap);

    var locale = document.documentElement.lang || "en-AU";
    function group(n, decimals) {
      try {
        return new Intl.NumberFormat(locale, {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        }).format(n);
      } catch (e) {
        return (Math.round(n * 100) / 100).toFixed(decimals);
      }
    }
    function money(cents) {
      var amount = cents / 100;
      if (/amount_no_decimals/.test(fmt)) {
        return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(amount, 0));
      }
      return fmt.replace(/\{\{\s*amount\s*\}\}/g, group(amount, 2));
    }
    /* "$30.00" reads heavy, so a whole amount drops its decimals and becomes
       "$30". Amounts with cents keep them. The separator is taken from the
       formatted string, not assumed to be a dot. */
    function moneyShort(cents) {
      var s = money(cents);
      return cents % 100 === 0 ? s.replace(/([.,])0{2}(?!\d)/, "") : s;
    }
    function priceText(cents) {
      return cfg.priceTrim ? moneyShort(cents) : money(cents);
    }

    function current() {
      var id = idInput && idInput.value;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return variants[0];
    }

    /* Seats left for the variant, or null when Shopify does not limit it. */
    function maxFor(v) {
      return v && typeof v.max === "number" ? v.max : null;
    }

    function qty() {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      return n;
    }

    /* ---------------------------------------------------------------
       People picker (Just me · 2 · 3 · 4+). The number box keeps
       name="quantity" and stays the one source of truth; the picker only
       writes into it. 4+ opens the box at 4 and keeps it at 4 or more.
       --------------------------------------------------------------- */
    function segValue() {
      for (var i = 0; i < segInputs.length; i++) {
        if (segInputs[i].checked) return parseInt(segInputs[i].value, 10) || 1;
      }
      return 1;
    }
    function syncSegments(v) {
      if (!segMode) return;
      var max = maxFor(v);
      var q = qty();
      if (max !== null && max > 0 && q > max) {
        q = max;
        qtyInput.value = q;
      }
      var pick = q >= 4 ? 4 : q;
      segInputs.forEach(function (r) {
        var n = parseInt(r.value, 10);
        r.disabled = max !== null && max > 0 && (n === 4 ? max < 4 : n > max);
        r.checked = n === pick;
      });
      if (elStepper) elStepper.hidden = pick < 4;
    }

    function render() {
      var v = current();
      if (!v) return;
      if (segMode) syncSegments(v);
      var q = qty();
      if (qtyInput) qtyInput.value = q;

      if (elNow) elNow.textContent = priceText(v.price);

      /* The compare-at price is only shown when it is GREATER than the selling
         price, and only while the section allows it at all. */
      var validCompare = cfg.showCompare !== false && v.compare != null && v.compare > v.price;
      if (elWas) {
        elWas.textContent = validCompare ? priceText(v.compare) : "";
        elWas.hidden = !validCompare;
      }
      if (elSave) {
        if (validCompare) {
          elSave.textContent = moneyShort(v.compare - v.price) + " OFF";
          elSave.hidden = false;
        } else {
          elSave.hidden = true;
        }
      }

      /* Per-unit cost: the line is hidden entirely when no serve count is set. */
      if (elPer) {
        if (v.units && v.units > 0) {
          elPer.innerHTML = v.units + " " + (cfg.unitNoun || "serve") +
            " · " + (cfg.unitLabel || "per serve") + " <b>" +
            money(Math.round(v.price / v.units)) + "</b>";
          elPer.hidden = false;
        } else {
          elPer.hidden = true;
        }
      }

      if (elTotal) elTotal.textContent = money(v.price * q);

      /* Running total next to the price, from 2 people up. */
      if (elSum) {
        if (cfg.totalLabel && q > 1) {
          elSum.textContent = cfg.totalLabel
            .replace(/\[n\]/g, String(q))
            .replace(/\[total\]/g, priceText(v.price * q));
          elSum.hidden = false;
        } else {
          elSum.hidden = true;
          elSum.textContent = "";
        }
      }

      if (elBtn && elBtn.getAttribute("aria-busy") !== "true") {
        elBtn.disabled = !v.available;
        var lbl = elBtn.querySelector("[data-alpha-label]");
        if (lbl) {
          var text = cfg.addLabel || "Add to cart";
          if (q > 1 && cfg.addLabelMany) text = cfg.addLabelMany.replace(/\[n\]/g, String(q));
          lbl.textContent = v.available ? text : (cfg.soldLabel || "Sold out");
        }
      }

      /* Express checkout sends the buyer straight to a wallet, so it has to
         disappear for a variant that cannot be bought. */
      if (elExpress) elExpress.hidden = !v.available;

      root.querySelectorAll("[data-alpha-variant]").forEach(function (el) {
        el.classList.toggle("on", String(el.dataset.alphaVariant) === String(v.id));
      });

      syncVenue(v);
      syncOptions(v);
    }

    /* ---------------------------------------------------------------
       Venue card: the card whose match word is in the session name is
       shown and its address goes into the order as properties[Venue].
       No match: no card and no property.
       --------------------------------------------------------------- */
    function syncVenue(v) {
      if (!venueWrap) return;
      var title = String((v && v.title) || "").toLowerCase();
      var hit = null;
      venueCards.forEach(function (c) {
        var m = (c.getAttribute("data-venue-match") || "").toLowerCase();
        var on = !hit && !!m && title.indexOf(m) !== -1;
        if (on) hit = c;
        c.hidden = !on;
      });
      venueWrap.hidden = !hit;
      if (venueProp) {
        venueProp.disabled = !hit;
        venueProp.value = hit ? hit.getAttribute("data-venue-prop") || "" : "";
      }
    }

    root.querySelectorAll("[data-alpha-variant] input[type=radio]").forEach(function (r) {
      r.addEventListener("change", function () {
        if (idInput) idInput.value = r.value;
        render();
        showVariantMedia(current());
      });
    });

    /* ---------------------------------------------------------------
       Gallery. The photos sit in a horizontal scroller that snaps one at
       a time (CSS), so swiping works on its own. Here: the thumbnails and
       arrows scroll it to a photo, the counter and the highlighted
       thumbnail follow whatever is on screen, a mouse can drag it, the
       arrow keys move it, a video slide plays only while it is on screen,
       and picking a variant that has its own photo brings that photo up.
       --------------------------------------------------------------- */
    var track = root.querySelector("[data-alpha-track]");
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll(".a-gal-slide")) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-alpha-thumb]"));
    var thumbStrip = root.querySelector("[data-alpha-thumbs]");
    var btnPrev = root.querySelector("[data-alpha-prev]");
    var btnNext = root.querySelector("[data-alpha-next]");
    var elIdx = root.querySelector("[data-alpha-idx]");
    var galIndex = 0;

    slides.forEach(function (s) {
      var vid = s.querySelector("video");
      if (!vid) return;
      vid.muted = true;
      vid.setAttribute("muted", "");
      vid.setAttribute("playsinline", "");
      /* With reduced motion nothing starts on its own; the controls are
         there to start it. */
      if (reduceMotion) vid.controls = true;
    });

    function slideWidth() {
      return track ? track.clientWidth || 1 : 1;
    }
    function indexFromScroll() {
      if (!track) return 0;
      var i = Math.round(track.scrollLeft / slideWidth());
      return Math.max(0, Math.min(slides.length - 1, i));
    }
    function markActive(i) {
      galIndex = i;
      /* The photo on screen and the ones either side are fetched now, so a
         swipe never lands on an empty square while a lazy image loads —
         browsers are slow to start lazy images inside a sideways scroller.
         A video slide has no lazy image and only loads once it is shown. */
      for (var k = i - 1; k <= i + 1; k++) {
        var img = slides[k] && slides[k].querySelector("img[loading='lazy']");
        if (img) img.loading = "eager";
      }
      slides.forEach(function (s, k) {
        var vid = s.querySelector("video");
        if (!vid) return;
        if (k === i) {
          if (!reduceMotion) {
            var pr = vid.play();
            if (pr && pr.catch) pr.catch(function () {});
          }
        } else if (!vid.paused) {
          vid.pause();
        }
      });
      if (elIdx) elIdx.textContent = String(i + 1);
      if (btnPrev) btnPrev.disabled = i <= 0;
      if (btnNext) btnNext.disabled = i >= slides.length - 1;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle("on", on);
        if (on) t.setAttribute("aria-current", "true");
        else t.removeAttribute("aria-current");
      });
      /* Keep the active thumbnail in view by scrolling the strip only —
         scrollIntoView would also move the page up or down. */
      var t = thumbs[i];
      if (thumbStrip && t) {
        var left = t.offsetLeft - thumbStrip.offsetLeft;
        var right = left + t.offsetWidth;
        if (left < thumbStrip.scrollLeft) {
          thumbStrip.scrollTo({ left: left, behavior: reduceMotion ? "auto" : "smooth" });
        } else if (right > thumbStrip.scrollLeft + thumbStrip.clientWidth) {
          thumbStrip.scrollTo({ left: right - thumbStrip.clientWidth, behavior: reduceMotion ? "auto" : "smooth" });
        }
      }
    }
    /* While a thumbnail, arrow or variant scrolls the track smoothly, the
       photos it passes on the way are not announced as the current one. */
    var goingTo = -1, goingUntil = 0, settle, drag = null;
    function goTo(i, instant) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      goingTo = i;
      goingUntil = Date.now() + 700;
      track.scrollTo({ left: i * slideWidth(), behavior: instant || reduceMotion ? "auto" : "smooth" });
      markActive(i);
      /* Safety net: some browsers (older Safari with snap points, or a page
         in a background tab) never finish a smooth scroll. If the photo has
         not arrived shortly after, jump straight to it. */
      clearTimeout(settle);
      settle = setTimeout(function () {
        if (galIndex === i && !drag && Math.abs(track.scrollLeft - i * slideWidth()) > 2) {
          track.scrollLeft = i * slideWidth();
        }
      }, 900);
    }
    /* Slides are found by media id, never by position: the gallery video
       sits between photos and would shift every index after it. */
    function showVariantMedia(v) {
      if (!v || v.media == null || !slides.length) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.mediaId) === String(v.media)) {
          if (i !== galIndex) goTo(i);
          return;
        }
      }
    }

    if (track && slides.length > 1) {
      if (btnPrev) { btnPrev.hidden = false; btnPrev.addEventListener("click", function () { goTo(galIndex - 1); }); }
      if (btnNext) { btnNext.hidden = false; btnNext.addEventListener("click", function () { goTo(galIndex + 1); }); }
      thumbs.forEach(function (t) {
        t.addEventListener("click", function () { goTo(parseInt(t.dataset.alphaThumb, 10) || 0); });
      });

      var ticking = false;
      track.addEventListener("scroll", function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var i = indexFromScroll();
          if (goingTo !== -1) {
            if (i === goingTo || Date.now() > goingUntil) goingTo = -1;
            else return;
          }
          if (i !== galIndex) markActive(i);
        });
      }, { passive: true });

      track.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight") { e.preventDefault(); goTo(galIndex + 1); }
        else if (e.key === "ArrowLeft") { e.preventDefault(); goTo(galIndex - 1); }
      });

      /* Mouse dragging. Touch and trackpads scroll natively; a mouse has
         no sideways gesture, so a drag is turned into a scroll and then
         settles on the nearest photo (or the next one, for a quick flick). */
      var justDragged = false;
      track.addEventListener("pointerdown", function (e) {
        if (e.pointerType !== "mouse" || e.button !== 0) return;
        goingTo = -1;
        drag = { x: e.clientX, left: track.scrollLeft, start: galIndex, moved: false, t: Date.now() };
      });
      window.addEventListener("pointermove", function (e) {
        if (!drag) return;
        var dx = e.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) < 5) return;
        if (!drag.moved) { drag.moved = true; track.classList.add("is-drag"); }
        track.scrollLeft = drag.left - dx;
      });
      window.addEventListener("pointerup", function (e) {
        if (!drag) return;
        var d = drag;
        drag = null;
        if (!d.moved) return;
        track.classList.remove("is-drag");
        var dx = e.clientX - d.x;
        var target = indexFromScroll();
        var quick = Date.now() - d.t < 300 && Math.abs(dx) > 30;
        if (target === d.start && (quick || Math.abs(dx) > slideWidth() * 0.18)) {
          target = d.start + (dx < 0 ? 1 : -1);
        }
        goTo(target);
        justDragged = true;
        setTimeout(function () { justDragged = false; }, 0);
      });
      track.addEventListener("click", function (e) {
        if (justDragged) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      /* A resize or a phone turning sideways changes the slide width, so
         the track is put back on the photo it was showing. */
      var rz, lastW = slideWidth();
      window.addEventListener("resize", function () {
        clearTimeout(rz);
        rz = setTimeout(function () {
          /* Phones fire resize when the address bar slides away; only a
             change of width needs the track re-aligned. */
          if (slideWidth() === lastW) return;
          lastW = slideWidth();
          goTo(galIndex, true);
        }, 120);
      });

      markActive(indexFromScroll());
    }

    /* ---------------------------------------------------------------
       Dropdowns (more than one option, or many sessions). The chosen
       values are matched to a variant, whose id goes into the form. Each
       entry says whether it can be booked together with what is chosen in
       the others. With a single option a sold-out session stays listed
       but cannot be picked.
       --------------------------------------------------------------- */
    var selects = Array.prototype.slice.call(root.querySelectorAll("select[data-alpha-option]"));

    function chosen() {
      return selects.map(function (s) { return s.value; });
    }
    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options;
        if (!o) continue;
        var ok = true;
        for (var k = 0; k < vals.length; k++) {
          if (o[k] !== vals[k]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }
    function syncOptions(v) {
      if (!selects.length) return;
      selects.forEach(function (s, i) {
        if (v.options && v.options[i] != null && s.value !== v.options[i]) s.value = v.options[i];
      });
      var vals = chosen();
      var single = selects.length === 1;
      selects.forEach(function (s, i) {
        Array.prototype.forEach.call(s.options, function (o) {
          if (o.dataset.base == null) o.dataset.base = o.textContent.trim();
          var probe = vals.slice();
          probe[i] = o.value;
          var m = findVariant(probe);
          var note = !m ? " — Unavailable" : (!m.available ? " — " + (cfg.soldLabel || "Sold out") : "");
          var text = o.dataset.base + note;
          if (o.textContent !== text) o.textContent = text;
          if (single) o.disabled = !m || !m.available;
        });
      });
    }

    selects.forEach(function (s, i) {
      s.addEventListener("change", function () {
        var vals = chosen();
        var m = findVariant(vals);
        if (!m) {
          /* That combination does not exist at all: keep the value just
             picked and move the other dropdowns to the closest variant
             that has it, preferring one that can still be booked. */
          var best = null, bestScore = -1;
          variants.forEach(function (v) {
            if (!v.options || v.options[i] !== vals[i]) return;
            var score = v.available ? 100 : 0;
            v.options.forEach(function (x, k) { if (x === vals[k]) score++; });
            if (score > bestScore) { best = v; bestScore = score; }
          });
          m = best;
        }
        if (!m) return;
        if (idInput) idInput.value = m.id;
        render();
        showVariantMedia(m);
        /* Keep the address in step, as Dawn does, so a shared or reloaded
           link opens on the same session. */
        try {
          var u = new URL(window.location.href);
          u.searchParams.set("variant", m.id);
          window.history.replaceState(window.history.state, "", u.toString());
        } catch (e) {}
      });
    });

    /* ---------------------------------------------------------------
       Add to cart.
       The form still posts to /cart/add, so with JavaScript off it
       behaves exactly as before and lands on /cart.

       after_add = drawer: the item is added in the background and the
       cart panel opens (Dawn's own section rendering).

       after_add = checkout: for a booking on its own the panel is a stop
       nobody needs, so:
         - cart empty            → add, then go to checkout
         - same session in cart  → set that line to the number chosen (no
                                   second add, so going back and pressing
                                   again never books twice), then checkout
         - anything else in cart → the panel opens as usual, so the buyer
                                   sees everything they are about to pay for
       Shopify answers "Only 1 item was added due to availability" with an
       error status even though it DID add some; then the panel opens on
       the real cart instead of jumping to checkout. Once Shopify has
       accepted an add, nothing below posts the form a second time.
       --------------------------------------------------------------- */
    var form = root.querySelector("form[action*='/cart/add']");
    var elErr = null;

    function showError(msg) {
      if (!elErr) {
        elErr = document.createElement("p");
        elErr.className = "a-atc-error";
        elErr.setAttribute("role", "alert");
        var row = root.querySelector(".a-qtyrow");
        if (row && row.parentNode) row.parentNode.insertBefore(elErr, row.nextSibling);
        else if (form) form.appendChild(elErr);
      }
      elErr.textContent = msg;
      elErr.hidden = !msg;
    }

    function busy(on) {
      if (!elBtn) return;
      if (on) {
        elBtn.setAttribute("aria-busy", "true");
        elBtn.disabled = true;
      } else {
        elBtn.removeAttribute("aria-busy");
        render(); /* restores disabled/label from the selected variant */
      }
    }

    function errText(j) {
      return (j && (j.description || j.message)) || "Sorry, that could not be added. Please try again.";
    }
    function getCart() {
      return fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); });
    }
    function qtyInCart(cart, vid) {
      var n = 0;
      (cart.items || []).forEach(function (it) {
        if (String(it.variant_id) === vid) n += it.quantity;
      });
      return n;
    }
    function goCheckout() {
      window.location.assign(cfg.checkoutUrl || "/checkout");
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        var drawer = document.querySelector("cart-drawer");
        var hasDrawer = !!(drawer && typeof drawer.renderContents === "function");
        var checkoutMode = cfg.afterAdd === "checkout";
        if (!window.fetch || !window.FormData) return;
        if (!checkoutMode && !hasDrawer) return;
        e.preventDefault();
        if (elBtn && elBtn.getAttribute("aria-busy") === "true") return;

        showError("");
        busy(true);

        var added = false;
        var body = new FormData(form);
        var vid = String(body.get("id"));
        var wanted = parseInt(body.get("quantity"), 10) || 1;

        function openWithFreshCart() {
          if (!hasDrawer) return Promise.resolve();
          /* No Accept header here: on a product URL, "application/json"
             makes Shopify answer with the product JSON instead of the
             rendered sections. */
          return fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              if (drawer.classList.contains("is-empty")) drawer.classList.remove("is-empty");
              drawer.renderContents({ id: vid, sections: sections });
            });
        }

        /* After a refused or partial add: say why, and if some seats did go
           in, open the panel on the real cart so nothing is out of step. */
        function afterRefusal(j, before) {
          busy(false);
          showError(errText(j));
          return getCart()
            .then(function (cart) {
              if (qtyInCart(cart, vid) > before) return openWithFreshCart();
            })
            .catch(function () {});
        }

        function fallback() {
          busy(false);
          if (added) {
            /* The item is in the cart: never add it a second time. */
            if (checkoutMode) goCheckout();
            else window.location.href = (window.routes && window.routes.cart_url) || "/cart";
          } else {
            /* The request never landed: fall back to the plain post. */
            form.submit();
          }
        }

        function addToDrawer(before) {
          body.append("sections", "cart-drawer,cart-icon-bubble");
          body.append("sections_url", window.location.pathname);
          return fetch("/cart/add.js", {
            method: "POST",
            body: body,
            headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json" }
          })
            .then(function (r) {
              if (r.ok) added = true;
              return r.json().then(function (j) { return { ok: r.ok, json: j }; });
            })
            .then(function (res) {
              var j = res.json || {};
              if (!res.ok || j.status) return afterRefusal(j, before);
              if (drawer.classList.contains("is-empty")) drawer.classList.remove("is-empty");
              drawer.renderContents(j);
              busy(false);
              /* Dawn's constants.js declares PUB_SUB_EVENTS with `const`, so
                 it is a global binding but not a property of window. */
              if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "noa-buybox",
                  productVariantId: body.get("id"),
                  cartData: j
                });
              }
            });
        }

        function addThenCheckout() {
          return fetch("/cart/add.js", {
            method: "POST",
            body: body,
            headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json" }
          })
            .then(function (r) {
              if (r.ok) added = true;
              return r.json().then(function (j) { return { ok: r.ok, json: j }; });
            })
            .then(function (res) {
              var j = res.json || {};
              if (!res.ok || j.status) return afterRefusal(j, 0);
              goCheckout();
            });
        }

        function setLineThenCheckout(line) {
          return fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ id: line.key, quantity: wanted })
          })
            .then(function (r) {
              return r.json().then(function (j) { return { ok: r.ok, json: j }; });
            })
            .then(function (res) {
              var j = res.json || {};
              if (!res.ok || j.status) {
                busy(false);
                showError(errText(j));
                return;
              }
              goCheckout();
            });
        }

        if (!checkoutMode) {
          /* How many of this variant the panel already holds, read before
             the request, so a partial add can be told apart from a refusal. */
          var before = 0;
          drawer.querySelectorAll(".quantity__input[data-quantity-variant-id='" + vid + "']").forEach(function (i) {
            before += parseInt(i.value, 10) || 0;
          });
          addToDrawer(before).catch(fallback);
          return;
        }

        getCart()
          .then(function (cart) {
            var items = cart.items || [];
            var others = items.filter(function (it) { return String(it.variant_id) !== vid; });
            var same = items.filter(function (it) { return String(it.variant_id) === vid; })[0];
            if (others.length) {
              if (hasDrawer) return addToDrawer(qtyInCart(cart, vid));
              /* No panel on this page: the plain post shows the cart. */
              busy(false);
              form.submit();
              return;
            }
            if (same) return setLineThenCheckout(same);
            return addThenCheckout();
          })
          .catch(fallback);
      });
    }

    /* Coming back with the browser's back button can restore the page from
       memory with the button still locked; unlock it. */
    window.addEventListener("pageshow", function (e) {
      if (e.persisted && elBtn && elBtn.getAttribute("aria-busy") === "true") busy(false);
    });

    /* ---------------------------------------------------------------
       Quantity: the − / + box, and the people picker when it is on.
       --------------------------------------------------------------- */
    function floorQty() {
      return segMode && segValue() >= 4 ? 4 : 1;
    }
    function ceilQty() {
      var max = segMode ? maxFor(current()) : null;
      return max !== null && max > 0 ? Math.min(99, max) : 99;
    }
    var minus = root.querySelector("[data-alpha-minus]");
    var plus = root.querySelector("[data-alpha-plus]");
    if (minus) minus.addEventListener("click", function () { qtyInput.value = Math.max(floorQty(), qty() - 1); render(); });
    if (plus) plus.addEventListener("click", function () { qtyInput.value = Math.min(ceilQty(), qty() + 1); render(); });
    if (qtyInput) qtyInput.addEventListener("change", function () {
      var n = qty();
      n = Math.max(floorQty(), Math.min(ceilQty(), n));
      qtyInput.value = n;
      render();
    });

    if (segMode) {
      segWrap.hidden = false;
      if (elStepper) elStepper.hidden = true;
      segInputs.forEach(function (r) {
        r.addEventListener("change", function () {
          if (!r.checked) return;
          var n = parseInt(r.value, 10) || 1;
          qtyInput.value = n >= 4 ? Math.max(4, Math.min(ceilQty(), qty())) : n;
          render();
        });
      });
    }

    /* ---------------------------------------------------------------
       "None of these times work?" — one tap is counted in Clarity and as
       a Shopify custom event; nothing personal is collected. One vote per
       visitor per product for the browser session.
       --------------------------------------------------------------- */
    var poll = root.querySelector("[data-alpha-poll]");
    if (poll) {
      var pollKey = "noa_slot_poll_" + (cfg.product || "");
      var opts = poll.querySelector(".a-poll-opts");
      var thanks = poll.querySelector(".a-poll-thanks");
      var thank = function () {
        if (opts) opts.hidden = true;
        if (thanks) thanks.hidden = false;
      };
      var voted = false;
      try { voted = window.sessionStorage.getItem(pollKey) === "1"; } catch (e) {}
      if (voted) thank();
      poll.querySelectorAll("[data-slot]").forEach(function (b) {
        b.addEventListener("click", function () {
          var slot = b.getAttribute("data-slot") || "";
          var city = poll.getAttribute("data-city") || "";
          try {
            if (typeof window.clarity === "function") {
              window.clarity("event", "slot_interest_" + slot.replace(/-/g, "_"));
            }
          } catch (e) {}
          try {
            if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
              window.Shopify.analytics.publish("noa_slot_interest", { city: city, slot: slot, product: cfg.product || "" });
            }
          } catch (e) {}
          try { window.sessionStorage.setItem(pollKey, "1"); } catch (e) {}
          thank();
        });
      });
    }

    /* Rating line → reviews, scrolled smoothly; the anchor still works
       without script. scroll-margin-top keeps the heading clear of the
       sticky header. */
    var rate = root.querySelector("[data-alpha-rating]");
    if (rate) {
      rate.addEventListener("click", function (e) {
        var id = (rate.getAttribute("href") || "").replace(/^#/, "");
        var target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
      });
    }

    render();
  }

  function init() {
    document.querySelectorAll("[data-alpha-pdp]").forEach(boot);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector("[data-alpha-pdp]");
    if (r) { r.dataset.alphaReady = ""; boot(r); }
  });
})();
